export default {
  onboarding:{
    continueAndConfigure: "Continuar",
    startForFree:"Prueba gratis la mejor app de gestión agrícola",
    trialPeriod:"Tienes 15 días de prueba,  no se necesita tarjeta de crédito.",
    trialPeriodMobile:"Registra y configura tu finca.",
    yourName:"Tu nombre",
    yourEmail:"Correo electrónico",
    yourPhone: "Número de celular para Whatsapp",
    createFieldWithTestData: "Crear un finca con datos de prueba",
    nameTitle:"Nombre",
    emailTitle:"Email de Trabajo",
    phoneTitle:"Teléfono",
    takenEmail: "Ya existe una cuenta asociada a dicho correo",
    costControl: "Los costos de tu finca 100% controlados",
    costInformation: "Toda la información de tu negocio en un solo lugar de forma simple, ordenada y en tiempo real.",
    allCrops: "Funciona en todo tipo de cultivos",
  },
  onboarding2:{
    configuration: "Configuración",
    instructions:"Ingresa los datos de tu campo, registra todos para tener una mejorar experiencia.",
    describeYourField: "Describe tu finca",
    fieldDescription: "Nombre, ubicación y tamaño",
    headquartersAndHarvest: "Lotes y Cultivos",
    yourCostCenter: "Tus centros de costos",
    workers:"Trabajadores",
    nameAndSalary: "Nombre y salario aproximado",
    supplies: "Insumos",
    suppliesDescription: "Nombre, cantidad y valor del producto",
    machineries:"Maquinarias",
    machineriesDescription:"Nombre y costo por hora",
    continueWithDemoField:"Seguir con finca demostrativo",
    noTime:"¿No tienes tiempo? utiliza datos de prueba",
    createAccount: "Crear Cuenta",
    createFieldWithDemoData: "Crear un finca con datos de prueba",
    offlineMode: "Modo Offline Sin internet",
    everywhereYouAre:"Descarga nuestra app e ingresa tus registros desde cualquier lugar, sin importar donde estés",
    syncWhenConnected: "Sincronizamos automáticamente tu información cada vez que te conectas a internet.",
  },
  onboarding3:{
    access:"Accesos",
    instructions:"Ingresa una palabra clave que te permitrá ingresar al sistema por web y app.",
    password:"Contraseña",
    passwordPlaceholder:"Clave",
    repeatPassword:"Repetir Contraseña",
    repeatPasswordPlaceholder:"Repetir la contraseña",
    generatePassword:"Generar contraseña",
    verifyPasswords:"Verifique contraseñas ingredasas",
    passwordDescription:"La contraseña debe contener al menos una letra mayúscula, minúsculas, un dígito y una longitud mínima de 6 letras.",
    warehouseControl: "Control e historial de bodega",
    itemsAndLaborControl: "Controla los insumos que utilizas en cada labor y las compras realizadas.",
    visualizeItems:"Visualiza la trazabilidad de cada uno de tus insumos",
  },
  onboarding4: {
    welcome:"Bienvenido",
    welcomeMessage:"Estás listo para ingresar a Agrapp te dejamos un vídeo para entender el uso de nuestra plataforma web y aplicación móvil.",
    storesMessage: "Para tener una mejor experiencia te recomendamos bajar nuestra aplicación en las diferentes tiendas:",
    contactInfoLabel:"Si deseas más información de nuestro producto puedes escribirnos vía ",
    enterToMyField:"Entrar a mi finca",
    contactUsViaWa:"Escríbenos vía Whastapp",
    farmerName:"Carlos Silva",
    farmerTestimony:"“Gracias a Agrapp sé exactamente cuánto estoy gastando en mis cultivos. Me ha ayudado a controlar las labores agrícolas y la asistencia (de mis trabajadores) de forma simple(y ordenada)”",
    farmerDescription:"Agricultor de Calera de Tango, Chile",
  },
  fieldModal:{
    describeYourField: "Describe tu finca",
    fieldDescription: "Nombre, ubicación y tamaño",
    companyName: "Nombre de la empresa",
    companyNamePlaceholder: "Nombre que identifique tu finca",
    location:"Ubicación",
    locationPlaceholder:"Comuna, región, país",
    size: "Superficie total (ha)",
    sizePlaceholder: "Número hectáreas",
  },
  headquarterModal:{
    headquartersAndHarvest: "Lotes y Cultivos",
    yourCostCenter: "Tus centros de costos",
    headquarterName: "Nombre del Lote",
    headquarterNamePlaceholder: "Nombre del sector del finca",
    crop:"Cultivo",
    cropPlaceholder:"Cultivo asociado al centro de costo",
    size: "Tamaño (ha)",
    sizePlaceholder: "Número hectáreas",
  },
  workersModal:{
    workers:"Trabajadores",
    nameAndSalary: "Nombre y salario mensual",
    name: "Nombre",
    namePlaceholder: "Nombre del Trabajador",
    approxSalary: "Salario Aproximado",
    approxSalaryPlaceholder:"Valor mensual",
  },
  suppliesModal:{
    supplies: "Insumos",
    suppliesDescription: "Nombre, cantidad y valor del producto",
    productName: "Nombre del producto",
    productNamePlaceholder:"Nombre comercial",
    quantity:"Cantidad",
    quantityPlaceholder:"Cantidad disponible",
    unitValue:"Valor Unitario",
    unitValuePlaceholder:"Costo",
    informationTag:"Después podrás agregar más detalle a la información de tus insumos ( tipo, ingrediente activo, carencia, etc).",
  },
  machineriesModal:{
    machineries:"Maquinarias",
    machineriesDescription:"Nombre y costo por hora",
    machineName:"Nombre del equipo",
    machineNamePlaceholder:"Nombre de la máquina",
    costPerHour:"Costo por Hora",
    costPerHourPlaceholder:"Aproximado",
  },
  common: {
    connected: "Conectado",
    step:"Paso",
    of:"de",
    save: "Guardar",
    edit: "Editar",
    add: "Agregar",
    omit: "Omitir",
    continue: "Continuar",
    generate: "Generar",
    invalidData:"Información Inválida",
    invalidDataDescription: "Por favor verifique la información ingresada.",
    back:"Volver",
  },
  formats: {
    decimalSeparator: ".",
    numberDelimiter: ",",
    middleDateFormat: "D [de] MMMM YYYY",
    longDateFormat: "dddd, D [de] MMMM YYYY",
    currencySymbol: "$",
    currencyISO: "CLP",
    currencyName: "peso",
  },
  httpErrors: {
    400: "Verificar información ingresada",
    401: "Acceso no autorizado",
    403: "Permisos insuficientes",
    404: "Recurso no encontrado",
    500: "Error del servidor",
  },
  notFound:{
    notFound: "No encontrado",
    routeDoesNotExists: "Acabas de llegar a una ruta que no existe ...",
    returnToSafePlace: "Regresar a la página principal",
  },
};
